import React from "react";
import TenantList from "go-security/components/Tenant/TenantList";

const AdminTenantsIndexPage = (): JSX.Element => {
	return <TenantList />;
};

export default AdminTenantsIndexPage;
